import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaEye, FaHeart, FaTimesCircle, FaArrowLeft, FaCheck, FaLightbulb, FaArrowRight, FaArrowCircleLeft, FaArrowCircleRight, FaQuestionCircle, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { getAuthToken } from '../../authToken';

const Demarrer_jeux = () => {
    useAuth(); // Vérifier l'authentification
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const [lives, setLives] = useState();  // Initialisation avec 10 vies

    const [qcms, setQcms] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [answers, setAnswers] = useState({});
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    const [currentQcmIndex, setCurrentQcmIndex] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [isloadingFin, setIsloadingFin] = useState(false);
    const [explanationVisible, setExplanationVisible] = useState(false);
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);


    const [textColor, setTextColor] = useState('#000000');
    const [bgColor, setBgColor] = useState('#ffffff');
    const [optionColors, setOptionColors] = useState({});
    const [showColorPicker, setShowColorPicker] = useState(false);


    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Quiz";
        }
    }, [user_id]);


    // const showAlert = (message, type = 'success') => {
    //     setAlert({ message, type });
    //     setTimeout(() => {
    //         setAlert({ message: '', type: '' });
    //     }, 5000);
    // };

    useEffect(() => {
        if (qcms.length > 0) {
            localStorage.setItem('currentQcmIndex', currentQcmIndex);
        }
    }, [currentQcmIndex, qcms]);


    const fetchQuiz = async () => {
        setIsLoading(true)
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-quiz/${user_id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (response.ok) {
                const data = await response.json();
                setQcms(data.quiz_data.questions);
                setLives(data.quiz_data.nbre_vies || 10);
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des quiz', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Récupérer les QCMs depuis le backend
    useEffect(() => {
        fetchQuiz();
    }, [user_id]);

    useEffect(() => {
        const currentAnswer = answers[qcms[currentQcmIndex]?.id];
        if (currentAnswer) {
            setSelectedAnswer({ qcmId: qcms[currentQcmIndex]?.id, value: currentAnswer });
        } else {
            setSelectedAnswer(null); // Aucun choix pour cette question
        }
        console.log("currentAnswer", currentAnswer);
    }, [currentQcmIndex, qcms, answers]);


    const handleAnswerChange = (qcmId, selectedValue) => {
        setSelectedAnswer({ qcmId, value: selectedValue });
        setExplanationVisible(false);
        setFeedbackVisible(false);
        setIsAnswerCorrect(null);

        setAnswers((prevAnswers) => {
            const updatedAnswers = { ...prevAnswers, [qcmId]: selectedValue };
            localStorage.setItem('answers', JSON.stringify(updatedAnswers));
            console.log("updatedAnswers", updatedAnswers);
            return updatedAnswers;
        });
    };

    const handleNextQcm = () => {
        if (currentQcmIndex < qcms.length - 1) {
            setCurrentQcmIndex(currentQcmIndex + 1);
            setExplanationVisible(false);
            setFeedbackVisible(false);
            setIsAnswerCorrect(null);
            setSelectedAnswer(null);  // Réinitialiser la réponse sélectionnée
            setIsCorrect(false); // Permettre de répondre à la nouvelle question
        }
    };

    const handlePreviousQcm = () => {
        if (currentQcmIndex > 0) {
            setCurrentQcmIndex(currentQcmIndex - 1);
            setExplanationVisible(false);
            setFeedbackVisible(false);
            setIsAnswerCorrect(null);
            setSelectedAnswer(null);  // Réinitialiser la réponse sélectionnée
            setIsCorrect(false); // Permettre de répondre à la nouvelle question
        }
    };


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const [isCorrect, setIsCorrect] = useState(false);

    const handleClick = (qcmId, reponse) => {
        if (!isCorrect) {  // Laisse répondre tant que ce n'est pas la bonne réponse
            setSelectedAnswer({ qcmId, value: reponse });
            const correct = reponse === qcms[currentQcmIndex].bonne_reponse;
            setIsCorrect(correct);
            handleAnswerChange(qcmId, reponse);  // Appeler la fonction externe si besoin

            if (!correct) {
                setLives(prevLives => {
                    const newLives = prevLives - 1;
                    if (newLives < 1) {
                        handleFinishQuiz();  // Terminer le quiz si les vies sont épuisées
                    }
                    return newLives;
                });
            } else {
                setLives(prevLives => {
                    const newLives = prevLives + 1;
                    return newLives;
                });
            }
        }
    };





    const handleFinishQuiz = async () => {
        try {
            setIsloadingFin(true)

            // Vérifier si aucune réponse n'a été sélectionnée
            if (!answers || Object.keys(answers).length === 0) {
                showAlert('Veuillez répondre aux quiz.', 'danger');
                return; // Bloquer l'exécution de la fonction
            }

            // Récupération des réponses
            const filteredAnswers = localStorage.getItem('answers') || "{}";
            const parsedAnswers = JSON.parse(filteredAnswers);

            // Préparation des données pour l'envoi
            const Donneés = {
                user_id,
                answers: parsedAnswers,
                nbre_vies: lives === 1 ? 0 : lives,
            };
            
            const token = localStorage.getItem('access_token');

            // Envoi au backend
            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-reponses/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(Donneés),
            });

            if (response.ok) {
                const result = await response.json();
                localStorage.removeItem('answers');
                navigate('/Quizz-terminer');
            } else {
                console.error("Erreur lors de l'envoi des réponses :", response.status);
                showAlert('Veuillez répondre aux questions.', 'danger')
            }
        } catch (error) {
            console.error("Erreur réseau lors de l'envoi des réponses :", error);
        } finally {
            setIsloadingFin(false)
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Quiz")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }




    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2><FaQuestionCircle size={25} className='mr-2' />Quiz
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>
                                    Bienvenue sur votre quiz ! Vous avez un nombre limité de vies : chaque mauvaise réponse vous en fait perdre une,
                                    tandis qu'une bonne réponse vous en fait gagner une. Si vous perdez toutes vos vies, le quiz se termine automatiquement.
                                    Utilisez les boutons Précédent et Suivant pour naviguer entre les questions, et cliquez sur Terminer le quiz pour soumettre vos réponses quand vous le souhaitez. Bonne chance !
                                    <br />
                                    <b>Légende des icônes : </b>
                                    <br />
                                    L'icone <FaHeart className="ivt-align-menu" /> exprime le nombre de vie.
                                    Le bouton <FaTimesCircle className="ivt-align-menu" /> permet de terminer le quiz.
                                    Le bouton <FaArrowLeft className="ivt-align-menu" /> permet d'aller sur la question précédente.
                                    Le bouton <FaArrowRight className="ivt-align-menu" /> permet d'aller sur la question suivante.
                                </small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Quizz-form`}> Quiz </Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-5">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <tr className='d-flex justify-content-between align-items-center'>
                                            <td>
                                                {qcms.length > 0 ? `${currentQcmIndex + 1} sur ${qcms.length}` : "0 sur 0"}
                                            </td>
                                            <td className='d-flex'>
                                                <button
                                                    className="btn btn-outline btn-secondary btn-sm mr-2"
                                                    onClick={() => setShowColorPicker(!showColorPicker)}
                                                    title="Personnaliser les couleurs"
                                                >
                                                    <i className="fa fa-paint-brush"></i>
                                                </button>

                                                {showColorPicker && (
                                                    <div className="color-palette" style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        right: '10',
                                                        zIndex: 1000,
                                                        backgroundColor: 'white',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '5px',
                                                        padding: '10px',
                                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                        width: '250px'
                                                    }}>
                                                        <div className="mb-2">
                                                            <label className="small">Couleur du texte:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={textColor}
                                                                onChange={(e) => setTextColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mb-2">
                                                            <label className="small">Couleur de fond:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={bgColor}
                                                                onChange={(e) => setBgColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mt-2 text-right">
                                                            <button
                                                                className="btn btn-sm btn-secondary mr-2"
                                                                onClick={() => {
                                                                    setShowColorPicker(false);
                                                                }}
                                                            >
                                                                Fermer
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-secondary"
                                                                onClick={() => {
                                                                    setTextColor('#000000');
                                                                    setBgColor('#ffffff');
                                                                    setOptionColors({});
                                                                }}
                                                            >
                                                                Réinitialiser
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="mr-2 d-flex">
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${currentSize + 1}px`;
                                                            });
                                                        }}
                                                        title="Zoomer"
                                                    >
                                                        <i className="fa fa-search-plus"></i>
                                                    </Button>
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm ml-1"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${Math.max(12, currentSize - 1)}px`;
                                                            });
                                                        }}
                                                        title="Dézoomer"
                                                    >
                                                        <i className="fa fa-search-minus"></i>
                                                    </Button>
                                                </div>
                                                <div className="hearts">
                                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                                        <FaHeart size={30} className="text-danger mb-1 mr-2" />
                                                        <span
                                                            style={{
                                                                position: 'absolute',
                                                                // top: 'px',
                                                                right: '9px',
                                                                fontSize: '15px',
                                                                fontWeight: 'bold',
                                                                color: 'white',
                                                                // backgroundColor: 'red',
                                                                borderRadius: '50%',
                                                                padding: '2px 6px',
                                                                minWidth: '18px',
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            {(lives ?? 0).toString().padStart(2, '0')}
                                                        </span>
                                                    </div>

                                                    <button className="btn btn-outline btn-success" onClick={handleFinishQuiz}>
                                                        <i className="fa fa-times-circle mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            {isloadingFin ? 'Chargement..' : 'Terminer le quiz'}
                                                        </span>
                                                    </button>
                                                </div>
                                            </td>

                                            {/* <td>
                                                <button className="btn btn-outline btn-warning" onClick={handleFinishQuiz}>
                                                    <i className="fa fa-times-circle mr-1"></i>
                                                    Terminer le quiz
                                                </button>
                                            </td> */}
                                        </tr>
                                    </div>

                                    {!isLoading ? (
                                        <div className="ibox-content" style={{
                                            backgroundColor: bgColor,
                                            transition: 'all 0.3s ease'
                                        }}>
                                            {qcms.length > 0 ? (
                                                <form>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcms[currentQcmIndex]?.id} />

                                                    {/* Affichage de la question avec couleur personnalisable */}
                                                    <div
                                                        id="question"
                                                        style={{
                                                            fontSize: '13px',
                                                            marginBottom: '15px',
                                                            color: textColor
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex]?.question }}
                                                    >
                                                    </div>

                                                    {/* Liste des réponses sous forme de cartes */}
                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', fontSize: '12px' }}>
                                                        {qcms[currentQcmIndex]?.reponses?.map((reponse, index) => {
                                                            const optionLetter = String.fromCharCode(65 + index);
                                                            const isSelected = selectedAnswer?.qcmId === qcms[currentQcmIndex]?.id && selectedAnswer?.value === reponse;
                                                            const isWrong = isSelected && !isCorrect;
                                                            const isGood = isSelected && isCorrect;

                                                            // Couleur personnalisée pour cette option
                                                            const optionColor = optionColors[optionLetter] || textColor;

                                                            // Déterminer la couleur de fond et de texte en fonction de l'état
                                                            let backgroundColor;
                                                            let textColorStyle;

                                                            if (isGood) {
                                                                backgroundColor = '#4CAF50'; // Vert pour correct
                                                                textColorStyle = '#fff';
                                                            } else if (isWrong) {
                                                                backgroundColor = '#E53935'; // Rouge pour incorrect
                                                                textColorStyle = '#fff';
                                                            } else if (isSelected) {
                                                                backgroundColor = optionColor; // Couleur personnalisée si sélectionnée
                                                                textColorStyle = '#fff';
                                                            } else {
                                                                backgroundColor = '#f8f9fa'; // Fond par défaut
                                                                textColorStyle = optionColor; // Couleur du texte personnalisée
                                                            }

                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className="card-reponse"
                                                                    style={{
                                                                        padding: '15px',
                                                                        borderRadius: '10px',
                                                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                                                        textAlign: 'center',
                                                                        cursor: isCorrect ? 'default' : 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        backgroundColor: backgroundColor,
                                                                        color: textColorStyle,
                                                                        border: isSelected ? `2px solid ${optionColor}` : 'none',
                                                                        transform: isSelected ? 'scale(1.02)' : 'scale(1)'
                                                                    }}
                                                                    onClick={() => handleClick(qcms[currentQcmIndex].id, reponse)}
                                                                >
                                                                    {optionLetter} - {reponse}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </form>
                                            ) : (
                                                <p>Aucun Thème trouvé pour ce quiz.</p>
                                            )}
                                        </div>

                                    ) : (

                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                            <span
                                                className="spinner-border spinner-border-lg text-success"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: '3rem', height: '3rem' }}
                                            ></span>
                                        </div>
                                    )}
                                    <div className="ibox-footer d-flex justify-content-end flex-wrap gap-2">

                                        <div className="ml-1">
                                            <Button
                                                onClick={handlePreviousQcm}
                                                style={{ display: currentQcmIndex === 0 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <FaArrowCircleLeft className="me-1 mr-1" />
                                                <span className='labelInfo1'>Précédent</span>
                                            </Button>
                                        </div>
                                        <div className="ml-1">
                                            <Button
                                                onClick={handleNextQcm}
                                                style={{ display: currentQcmIndex === qcms.length - 1 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <span className='labelInfo1'>Suivant</span>
                                                <FaArrowCircleRight className="me-1 ml-1" />
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demarrer_jeux;
